import { ButtonComponentConfig } from '../button';
import { IconType } from '../icon';

export const ToolbarConfig: ButtonComponentConfig = {
  text: 'SHARED.BACK',
  icon: {
    name: 'arrow-left',
    type: IconType.NgZorro
  }
};
